import type { FunctionComponent } from 'react'
import { useMemo } from 'react'
import styled from 'styled-components'
import type { LatLngLiteral } from 'leaflet'
import { wgs84ToRd } from '../../utils/coordinateReferenceSystem'
import formatDate from '../../utils/formatDate'

const ViewerInfoBarStyle = styled.div<{ $showLargeMap: boolean }>`
  background-color: rgba(255, 255, 255, 0.3);
  display: none;
  flex-direction: column;
  white-space: nowrap;
  font-size: 1rem;

  span {
    display: inline-block;
    padding: 0.5rem;
  }

  @media screen and (min-width: ${({ $showLargeMap }) => ($showLargeMap ? '34rem' : '68rem')}) {
    display: flex;
  }

  @media screen and (min-width: ${({ $showLargeMap }) => ($showLargeMap ? '52rem' : '112rem')}) {
    flex-direction: row;

    span {
      &:not(:last-of-type) {
        border-right: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
`

export interface ViewerInfoBarProps {
  location: LatLngLiteral
  date?: Date
  showLargeMap: boolean
  panoFullScreen?: boolean
}

const ViewerInfoBar: FunctionComponent<ViewerInfoBarProps> = ({
  location,
  date,
  showLargeMap,
  panoFullScreen,
}) => {
  const { x: rdX, y: rdY } = useMemo(() => wgs84ToRd(location), [location])
  const formattedDate = useMemo(
    () =>
      date
        ? formatDate(date, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          })
        : null,
    [date],
  )

  if (!panoFullScreen) {
    return null
  }

  return (
    <ViewerInfoBarStyle $showLargeMap={showLargeMap}>
      <span>{formattedDate}</span>
      <span>
        {rdX.toFixed(2)}, {rdY.toFixed(2)}
      </span>
      <span>
        {location.lat.toFixed(7)}, {location.lng.toFixed(7)}
      </span>
    </ViewerInfoBarStyle>
  )
}

export default ViewerInfoBar
